/**
 * @param types Assessment types: Who5, Phq2, Gad2, Phq8, Phq9, Gad7
 * @param name Assessment name, who5, phq2, gad2, phq8, phq9, gad7
 * @returns boolean
 */
export const isAssessmentMatching = (name: string, types: string[]) => {
    return types.some(type => type.toLowerCase() === name);
};
